import React from 'react'
import { t } from 'ttag'
import { Modal } from 'components/shared/Modal/Modal'
import cx from 'classnames'

import styles from './GmaModal.module.scss'

export const GMA_RESPONSES = [
  { label: 'well below average', value: 0 },
  { label: 'slightly below average', value: 1 },
  { label: 'average', value: 2 },
  { label: 'slightly above average', value: 3 },
  { label: 'well above average', value: 4 },
]

export const GmaModal = ({
  onCancel,
  onClose,
  onConfirm,
  gmaScore,
  setGmaScore,
  jobSeeker,
  isOpen,
}) => {
  return (
    <Modal
      cancelLabel={t`Close`}
      confirmLabel={t`Save`}
      className={styles.modal}
      portalClassName={styles.portal}
      title={
        <div
          className={styles.mainTitle}
        >{t`General Mental Ability (GMA)`}</div>
      }
      {...{
        onConfirm,
        onCancel,
        onClose,
        isOpen,
      }}
    >
      <Modal.Header />
      <Modal.Content className={styles.content}>
        <div className={styles.innerContent}>
          {`GMA describes how quickly and efficiently a person learns, processes
          information, and solves new problems. Estimate general mental ability
          of`}{' '}
          {`${jobSeeker.name}`}:{' '}
        </div>
        <div className={styles.responses}>
          {GMA_RESPONSES.map(({ label, value }) => (
            <div
              className={cx(styles.response, {
                [styles.selected]: gmaScore === value,
              })}
              key={value}
              onClick={() => setGmaScore(value)}
            >
              {label}
            </div>
          ))}
        </div>
      </Modal.Content>

      <Modal.Footer className={styles.footer} />
    </Modal>
  )
}
